module.exports = __webpack_public_path__ + "img/btn_menu_gwsh.3de82c07.png";